import ProjectsPage from "./pages/ProjectsPage";
import BannersPage from './pages/BannersPage';
import LoginPage from "./pages/LoginPage";
import UsersPage from "./pages/UsersPage";
import HistoryPage from "./pages/HistoryPage";

const AppRoutes = [
    {
        index: true,
        element: <ProjectsPage />
    },
    {
        path: '/banners-page/:projectId',
        element: <BannersPage />
    },
    {
        path: '/banners-page',
        element: <BannersPage />
    },
    {
        path: '/users-page',
        element: <UsersPage />
    },
    {
        path: '/history-page',
        element: <HistoryPage />
    },
    {
        path: 'login',
        element: <LoginPage />
    }
];

export default AppRoutes;
